/*
 * This image is the filled/selected radio button.  The outer color is hard-coded to always be gray, while the
 * inner/fill circle is allowed to change colors.
 */
export const props = { viewBox: "0 0 24 24" };
export const innerHTML = `
<svg>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M12 3.75C7.44365 3.75 3.75 7.44365 3.75 12C3.75 16.5563 7.44365 20.25 12 20.25C16.5563 20.25 20.25 16.5563 20.25 12C20.25 7.44365 16.5563 3.75 12 3.75ZM2.25 12C2.25 6.61522 6.61522 2.25 12 2.25C17.3848 2.25 21.75 6.61522 21.75 12C21.75 17.3848 17.3848 21.75 12 21.75C6.61522 21.75 2.25 17.3848 2.25 12Z" fill="#979797"/>
    <circle cx="12" cy="12" r="6"/>
</svg>`;
